export default "__VITE_ASSET__3rIx6o2Z__"